import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import styles from './styles.module.scss'

import wisprLogo from '@/assets/images/wisprLogo.svg?url'
import Button from '@/components/Button'
import { useToast } from '@/components/Toast/ToastContext'
import { AppDispatch } from '@/store'
import { selectTeamName } from '@/store/features/domain/domainSlice'
import {
  fetchMyJoinRequestsThunk,
  selectIsMyJoinRequestsLoading,
  selectMyJoinRequests,
} from '@/store/features/joinRequest/joinRequestSlice'
import { inviteSelfThunk } from '@/store/features/member/memberSlice'
import { selectEmail, selectSubscriptionStatus } from '@/store/features/user/userSlice'
import { SubscriptionStatus } from '@/types'

// TODO: We should fetch enterprise invitations and match by email so that we can show "you've been invited to join the team"
export default function TeamExists() {
  const dispatch = useDispatch<AppDispatch>()
  const [isSendingRequest, setIsSendingRequest] = useState(false)
  const currentEmail = useSelector(selectEmail)
  const { updateToast } = useToast()
  const teamName = useSelector(selectTeamName)
  const myJoinRequests = useSelector(selectMyJoinRequests)
  const isMyJoinRequestsLoading = useSelector(selectIsMyJoinRequestsLoading)

  useEffect(() => {
    dispatch(fetchMyJoinRequestsThunk())
  }, [dispatch])

  const hasPendingRequest = myJoinRequests.length > 0

  const handleRequestToJoinTeam = async () => {
    try {
      setIsSendingRequest(true)
      await dispatch(
        inviteSelfThunk({
          message: `${currentEmail} would like to join the Flow team`,
        })
      ).unwrap()
      updateToast('Successfully sent message to admins to add you to the team', 'success')
      // Refresh my join requests to show the new one
      await dispatch(fetchMyJoinRequestsThunk())
    } catch (error) {
      console.error(error)
      updateToast(error as string, 'error')
    } finally {
      setIsSendingRequest(false)
    }
  }

  // It's important to select the user's subscription status, not the domains
  // TODO: We should also check that the domain does not have a subscription to show the "will pay" message
  const userSubscriptionStatus = useSelector(selectSubscriptionStatus)
  const isPro = userSubscriptionStatus === SubscriptionStatus.Active

  return (
    <div className={styles.createOrgContainer}>
      <img src={wisprLogo} alt="Wispr" className={styles.logo} />
      {teamName && <h5>{teamName}</h5>}
      <div className={styles.information}>
        {/* eslint-disable-next-line react/no-unescaped-entities */}
        Looks like there's a team on your domain
      </div>
      {isPro && (
        <p className={styles.information}>
          * If you join this team when it has no billing info, you will become the payer for the team.
        </p>
      )}

      <div className={styles.createOrgForm}>
        <div className={styles.createOrgFormRow}>
          <Button
            title={hasPendingRequest ? 'Request sent' : 'Request to join team'}
            width={200}
            onClick={handleRequestToJoinTeam}
            isLoading={isSendingRequest}
            isDisabled={hasPendingRequest || isMyJoinRequestsLoading}
            type="dark"
          />
        </div>
      </div>
    </div>
  )
}
